import React from 'react'
import axios from 'axios'
import './rotasModule.css'
import { formatDate, getNormalizedRoute } from './rotaHelpers'

export default class ArquivaRota extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            list: null,
            normalized: null,
            loaded: false,
            obsFiscal: '',
            saving: false
        }
    }

    componentDidMount() {
        const id = this.props.match.params.id
        axios(`/api/rota/rotaView/${id}`)
            .then((resp) => this.setState({
                list: resp.data,
                normalized: getNormalizedRoute(resp.data),
                obsFiscal: resp.data.obsFiscal || '',
                loaded: true
            }))
            .catch((error) => alert(error.response?.data || 'Erro ao carregar rota.'))
    }

    updateRealizada = (section, indice, realizada) => {
        this.setState((prevState) => ({
            normalized: {
                ...prevState.normalized,
                [section]: prevState.normalized[section].map((item) => item.indice === indice ? { ...item, realizada } : item)
            }
        }))
    }

    arquiva = async () => {
        this.setState({ saving: true })
        try {
            await axios.post('/api/rota/arquiva2', {
                _id: this.state.list._id,
                obsFiscal: this.state.obsFiscal,
                estabelecimentos: this.state.normalized.itensPrincipais,
                alternativas: this.state.normalized.itensAlternativos
            })
            alert('Rota arquivada.')
            window.location = '/rotas'
        } catch (error) {
            alert(error.response?.data || 'Erro ao arquivar rota.')
        } finally {
            this.setState({ saving: false })
        }
    }

    renderDecisionAudit() {
        const { normalized } = this.state
        if (!normalized || !['aprovada', 'reprovada'].includes(normalized.situacao)) return null

        return (
            <div className="rota-audit-box mt-4">
                <p className="rota-eyebrow text-white-50 mb-1">Auditoria</p>
                <h3 className="mb-3">Decisão registrada</h3>
                <div><strong>Decisão:</strong> {normalized.decision.tipoDecisao === 'reprovada' ? 'Reprovada' : 'Aprovada'}</div>
                <div><strong>Responsável:</strong> {normalized.decision.usuarioDecisaoNome || 'Não informado'}</div>
                <div><strong>Hash:</strong> {normalized.decision.hashDecisao || 'Não informado'}</div>
                {normalized.decision.obsCoord && <div className="mt-2"><strong>Observações:</strong> {normalized.decision.obsCoord}</div>}
            </div>
        )
    }

    renderExecutionCard(item, section, alternative = false) {
        return (
            <div className="col-12 mb-3" key={`${section}-${item.indice}`}>
                <div className={`rota-item-card ${alternative ? 'alternative' : ''}`}>
                    <div className="d-flex flex-wrap justify-content-between align-items-start">
                        <div>
                            <strong>{item.estabelecimento || 'Estabelecimento não informado'}</strong>
                            <div className="rota-muted">{item.municipio || 'Município não informado'} · {formatDate(item.data)}</div>
                        </div>
                        <div className="rota-radio-group mt-3 mt-md-0">
                            <div className={`rota-radio-option ${item.realizada === true ? 'active realizada' : ''}`} onClick={() => this.updateRealizada(section, item.indice, true)}>
                                <strong>Realizada</strong>
                                <div className="rota-muted">Marcar visita executada.</div>
                            </div>
                            <div className={`rota-radio-option ${item.realizada === false ? 'active nao-realizada' : ''}`} onClick={() => this.updateRealizada(section, item.indice, false)}>
                                <strong>Não realizada</strong>
                                <div className="rota-muted">Marcar visita não executada.</div>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-6"><span className="rota-label">Endereço</span><div>{item.endereco || 'Não informado'}</div></div>
                        <div className="col-md-3"><span className="rota-label">Motivo</span><div>{item.motivo || 'Não informado'}</div></div>
                        <div className="col-md-3"><span className="rota-label">Diária</span><div>{item.diaria || 'Não informado'} · {item.tipoDiaria || 'Tipo não informado'}</div></div>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        if (!this.state.loaded || !this.state.normalized) return <div className="container rota-page">Carregando...</div>
        const { normalized } = this.state

        return (
            <div className="container rota-page">
                <div className="rota-hero">
                    <div className="d-flex flex-wrap justify-content-between align-items-start">
                        <div>
                            <p className="rota-eyebrow mb-1">Arquivamento</p>
                            <h1 className="rota-title mb-2">Concluir rota</h1>
                            <p className="rota-subtitle mb-0">Revise os itens normalizados, registre execução e arquive com segurança em formato estruturado.</p>
                        </div>
                        <span className={`rota-status-pill ${normalized.situacao}`}>{normalized.situacao.toUpperCase()}</span>
                    </div>
                </div>
                <div className="rota-surface mb-4">
                    <p className="rota-eyebrow mb-1">Resumo</p>
                    <h3 className="rota-section-title mb-2">{normalized.fiscal} · {normalized.estado}</h3>
                    <p className="rota-muted mb-0">{normalized.analytics.totalPrincipais} principais · {normalized.analytics.totalAlternativos} alternativas</p>
                </div>
                <div className="rota-surface mb-4">
                    <p className="rota-eyebrow mb-1">Rotas principais</p>
                    <h2 className="rota-section-title mb-3">Marcação de execução</h2>
                    <div className="row">{normalized.itensPrincipais.map((item) => this.renderExecutionCard(item, 'itensPrincipais'))}</div>
                </div>
                <div className="rota-surface mb-4">
                    <p className="rota-eyebrow mb-1">Rotas alternativas</p>
                    <h2 className="rota-section-title mb-3">Plano alternativo</h2>
                    <div className="row">{normalized.itensAlternativos.map((item) => this.renderExecutionCard(item, 'itensAlternativos', true))}</div>
                </div>
                {this.renderDecisionAudit()}
                <div className="rota-surface mt-4">
                    <label className="rota-label">Observações do fiscal</label>
                    <textarea rows="4" className="form-control rota-input mb-3" value={this.state.obsFiscal} onChange={(e) => this.setState({ obsFiscal: e.target.value })} />
                    <label className="rota-label">Observações da coordenação</label>
                    <div className="form-control rota-input">{normalized.obsCoord || 'Sem observações da coordenação.'}</div>
                    <div className="d-flex justify-content-end mt-4">
                        <button className="btn rota-primary-button" onClick={this.arquiva} disabled={this.state.saving}>{this.state.saving ? 'Arquivando...' : 'Arquivar rota'}</button>
                    </div>
                </div>
            </div>
        )
    }
}
